import { WidgetTeacherSectionItem } from './widget-teacher-section-item.model';

export class WidgetStudentCourse {
  id: number;
  title: string;
  classId: number;
  className: string;
  sections: {
    content: WidgetTeacherSectionItem[];
    more: boolean;
    page: number;
  };
  hasGrading: boolean;
  constructor(data: any) {
    this.id = data.id;
    this.title = data.title;
    this.classId = data.classId;
    this.className = data.className;
    this.sections = { content: [], more: true, page: 0 };
    this.hasGrading = data.hasGrading;
  }
}